module.exports = __webpack_public_path__ + "static/img/53.948aaa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/53.png
// module id = PBzr
// module chunks = 0